var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.66309V24.0002H25.2697V5.66309H1ZM13.1753 15.5009L3.5465 7.0923H22.8041L13.1753 15.5009ZM2.42921 21.9728V8.01407L10.4214 14.9934L2.42921 21.9728ZM3.91706 22.5709H22.4335L14.8428 15.9422L13.1753 17.3983L11.5078 15.9422L3.91706 22.5709ZM15.9292 14.9934L23.8405 21.9021V8.08471L15.9292 14.9934Z",
    fill: "#E85558",
    stroke: "#E85558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8651 12.1348C28.2161 12.1348 30.9326 9.41836 30.9326 6.06742C30.9326 2.71647 28.2161 0 24.8651 0C21.5142 0 18.7977 2.71647 18.7977 6.06742C18.7977 9.41836 21.5142 12.1348 24.8651 12.1348Z",
    fill: "#E85558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3089 2.34619H24.4177V9.78495H25.3089V2.34619Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5833 6.51131V5.62012L21.1445 5.62012V6.51131L28.5833 6.51131Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEmailIcon);
export default __webpack_public_path__ + "static/media/new-email-icon.6a113100a6f1c2042c5590e227da93bf.svg";
export { ForwardRef as ReactComponent };